/** Permission slugs — must match backend `permissions.slug` values. */
export const PERMISSIONS = {
  USER_CREATE: "user.create",
  USER_READ: "user.read",
  USER_UPDATE: "user.update",
  USER_DELETE: "user.delete",

  ROLE_CREATE: "role.create",
  ROLE_READ: "role.read",
  ROLE_UPDATE: "role.update",
  ROLE_DELETE: "role.delete",

  PERMISSION_CREATE: "permission.create",
  PERMISSION_READ: "permission.read",
  PERMISSION_UPDATE: "permission.update",
  PERMISSION_DELETE: "permission.delete",

  PROJECT_CREATE: "project.create",
  PROJECT_READ: "project.read",
  PROJECT_UPDATE: "project.update",
  PROJECT_DELETE: "project.delete",

  VENDOR_CREATE: "vendor.create",
  VENDOR_READ: "vendor.read",
  VENDOR_UPDATE: "vendor.update",
  VENDOR_DELETE: "vendor.delete",

  EXPENSE_CREATE: "expense.create",
  EXPENSE_READ: "expense.read",
  EXPENSE_UPDATE: "expense.update",
  EXPENSE_DELETE: "expense.delete",
};

/** Minimum permission to open a route (read for list pages). */
export const ROUTE_PERMISSIONS = {
  "/": null,
  "/access/users": PERMISSIONS.USER_READ,
  "/access/roles": PERMISSIONS.ROLE_READ,
  "/projects": PERMISSIONS.PROJECT_READ,
  "/vendors": PERMISSIONS.VENDOR_READ,
  "/expenses": PERMISSIONS.EXPENSE_READ,
  "/settings": null,
  "/about": null,
};

export const DASHBOARD_STAT_PERMISSIONS = {
  users: PERMISSIONS.USER_READ,
  projects: PERMISSIONS.PROJECT_READ,
  vendors: PERMISSIONS.VENDOR_READ,
};
